module.exports = __webpack_public_path__ + "img/2_etablissement_bleu.d1d362c2.svg";